import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { FilterChangeModel, FiltersChangeAction, FiltersEventType } from "@gtmhub/hub/events";
import { IHubFilter } from "@gtmhub/hub/models/hub";
import { HubService } from "@gtmhub/hub/services/hub";
import { BroadcastService } from "@webapp/core/broadcast/services/broadcast.service";

@Injectable()
export class CustomViewsService {
  private customViews$: BehaviorSubject<FilterChangeModel[]> = new BehaviorSubject<FilterChangeModel[]>([]);
  private loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private broadcastService: BroadcastService, private hubService: HubService) {
    this.broadcastService.on(FiltersEventType.FILTER_CHANGED).subscribe((changeDefinition: { filter: FilterChangeModel; action: FiltersChangeAction }) => {
      switch (changeDefinition.action) {
        case "delete":
          {
            this.customViews$.next(this.customViews$.value.filter((filter) => filter.id !== changeDefinition.filter.id));
          }
          break;
        case "create":
          {
            this.customViews$.next([changeDefinition.filter, ...this.customViews$.value]);
          }
          break;
        case "update":
          {
            this.customViews$.next(
              this.customViews$.value.map((filter) => {
                return filter.id === changeDefinition.filter.id ? changeDefinition.filter : filter;
              })
            );
          }
          break;
      }
    });

    this.hubService.getFilters("hub").then((filters: IHubFilter[]) => {
      this.loading$.next(false);
      this.customViews$.next(
        filters.map((filter) => {
          return {
            id: filter.id,
            name: filter.name,
          };
        })
      );
    });
  }

  public getCustomViews$(): Observable<FilterChangeModel[]> {
    return this.customViews$.asObservable();
  }

  public getLoading$(): Observable<boolean> {
    return this.loading$.asObservable();
  }
}
